import type { IndustryCategoryEnum } from '@ulysses-inc/harami_api_client'

export const industryTemplatesQueryKeys = {
  all: ['industryTemplates'] as const,
  byIndustry: (industry: IndustryCategoryEnum, key?: string) =>
    [...industryTemplatesQueryKeys.all, industry, key] as const,
}
